/**
 * Tokens de UI compartidos: BaseTemplate (home black), BaseTemplateBlack y SiteLayout dark.
 * Premium Black Style — profesional para creadora de contenido / modelo.
 */

export const baseTemplateDarkShell = {
  pageRoot: "min-h-screen bg-black text-white font-body antialiased",
  header:
    "sticky top-0 z-50 w-full border-b border-white/10 bg-black/95 backdrop-blur-xl pt-[env(safe-area-inset-top,0px)]",
  logoLink:
    "inline-flex items-center gap-2 text-lg sm:text-xl font-display font-semibold text-white whitespace-nowrap tracking-tight hover:opacity-80 transition-opacity",
  navDesktopLink:
    "font-body text-white/60 hover:text-white ui-transition duration-200 font-medium focus:outline-none focus:ring-2 focus:ring-white/20 rounded tracking-tight text-[13px] uppercase",
  navDesktopLinkActive:
    "font-body text-white ui-transition duration-200 font-medium focus:outline-none focus:ring-2 focus:ring-white/20 rounded tracking-tight text-[13px] uppercase",
  mobileMenuPanel: "md:hidden border-t border-white/10 bg-black/98 backdrop-blur-xl",
  mobileNavLink:
    "block px-3 py-2.5 font-body text-white/60 hover:text-white transition-colors font-medium tracking-tight uppercase text-sm",
  menuButton:
    "text-white/70 hover:text-white focus:outline-none focus:ring-2 focus:ring-white/20 rounded",
  /** CTA hero: premium black style con glassmorphism sutil */
  ctaGlass:
    "inline-flex items-center gap-3 py-4 px-6 max-w-[380px] mx-auto rounded-full " +
    "border border-white/20 bg-white/10 " +
    "backdrop-blur-xl backdrop-saturate-150 " +
    "shadow-[0_8px_32px_rgba(0,0,0,0.4)] " +
    "transition-[background-color,box-shadow,transform,border-color] duration-300 ease-out " +
    "hover:bg-white/[0.15] hover:border-white/30 hover:shadow-[0_12px_48px_rgba(0,0,0,0.6)] hover:scale-[1.02] " +
    "active:scale-[0.98]",
} as const;

/**
 * UI de carga diferida mientras llegan site-settings (banner / galería).
 * Home usa `dark`; `light` queda por si algún surface legacy lo necesita.
 */
export const baseTemplateDeferredUi = {
  light: {
    overlay: "pointer-events-none absolute inset-0 z-[2] flex items-center justify-center",
    mark: "text-black/70",
    ring: "border-black/40",
    label: "text-black/45",
    skeleton: "bg-gray-200/90",
    shimmer: "via-white/55",
    monogramBg: "bg-black/[0.06]",
  },
  dark: {
    overlay: "pointer-events-none absolute inset-0 z-[2] flex items-center justify-center",
    mark: "text-white/80",
    ring: "border-white/40",
    label: "text-white/45",
    skeleton: "bg-zinc-900/90",
    shimmer: "via-white/10",
    monogramBg: "bg-white/10",
  },
} as const;

export type BaseTemplateDeferredUiTone = keyof typeof baseTemplateDeferredUi;
